<template>
    <ckeditor
        :config="editorConfig"
        :value="this.value"
        :editor="editor"
        @input="emit"
        @ready="onReady">
    </ckeditor>
</template>

<script>


const customColorPalette = [
    {
        color: 'rgb(0, 0, 0)',
        label: 'Black'
    },
    {
        color: 'rgb(77, 77, 77)',
        label: 'Dim grey'
    },
    {
        color: 'rgb(153, 153, 153)',
        label: 'Grey'
    },
    {
        color: 'rgb(230, 230, 230)',
        label: 'Light grey'
    },
    {
        color: 'rgb(255, 255, 255)',
        label: 'White',
        hasBorder: true
    },
    {
        color: 'rgb(230, 76, 76)',
        label: 'Red'
    },
    {
        color: 'rgb(230, 153, 76)',
        label: 'Orange'
    },
    {
        color: 'rgb(230, 230, 76)',
        label: 'Yellow'
    },
    {
        color: 'rgb(153, 230, 76)',
        label: 'Light green'
    },
    {
        color: 'rgb(76, 230, 76)',
        label: 'Green'
    },
    {
        color: 'rgb(76, 230, 153)',
        label: 'Aquamarine'
    },
    {
        color: 'rgb(76, 230, 230)',
        label: 'Turquoise'
    },
    {
        color: 'rgb(76, 153, 230)',
        label: 'Light blue'
    },
    {
        color: 'rgb(76, 76, 230)',
        label: 'Blue'
    },
    {
        color: 'rgb(153, 76, 230)',
        label: 'Purple'
    }
];

import CKEditor   from 'ckeditor4-vue';
Vue.use(CKEditor);
export default {
    components: {
        ckeditor: CKEditor.component
    },
    name: "ckeditor-template",
    props  : ['value', 'options'],
    data() {
        return {
            extraPlugins : 'widget',
            editor      : CKEditor,
            editorConfig: {
                resize_enabled: false,
                removePlugins:'easyimage,image',
                extraPlugins : 'pastefromword,widget,pastefromgdocs,uploadimage,uploadwidget,image2',
                uploadUrl: '/api/ckeditor-template-resource-files',
                autoEmbed_widget: 'addSignature,addInitials,addDate,contactName,contactEmail,contactCompany,projectAddress,baseBid',
                autoUpdateElement: true,
                allowedContent:true,
                removeButtons:'Save,NewPage,ExportPdf,Preview,Subscript,Superscript,CopyFormatting,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Scayt,SelectAll,Find,Replace,Redo,Undo,Cut,Copy,Paste,PasteText,PasteFromWord,Templates,Source,BidiLtr,BidiRtl,Language,Anchor,Unlink,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About,Print,CreateDiv',
                language: 'en',
                wordcount: {
                    showCharCount: true,
                    showWordCount: true,
                    showParagraphs: true,
                    countSpacesAsChars: true,
                    countHTML: true,
                },
                fontSize: {
                    options: ['5px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
                },
                image: {
                    toolbar: [
                        'imageTextAlternative',
                        'imageStyle:full',
                        'imageStyle:side'
                    ]
                },
                table: {
                    contentToolbar: [
                        'tableColumn',
                        'tableRow',
                        'mergeTableCells',
                        'tableCellProperties',
                        'tableProperties'
                    ],
                    tableProperties: {
                        borderColors: customColorPalette,
                        backgroundColors: customColorPalette
                    },
                    tableCellProperties: {
                        borderColors: customColorPalette,
                        backgroundColors: customColorPalette
                    }
                },
                fontBackgroundColor: {
                    colors: customColorPalette
                },
                fontColor: {
                    colors: customColorPalette
                },
                mention: {
                    feeds: [
                        {
                            marker: '@',
                            feed: this.getFeedItems,
                            minimumCharacters: 1
                        }
                    ]
                },
                toolbarGroups: [
                    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'align', 'blocks', 'list', 'indent', 'bidi', 'paragraph' ] },
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ],
                pasteFromWordNumberedHeadingToList:true,
                pasteFromWord_inlineImages: true,
                pasteFromWordRemoveStyles: true,
                pasteFromWordRemoveFontStyles: true,
                contentsCss: '/css/ckeditor-sequence.css',
            },
            oldEditorValue:this.value,
            templateEditor: null,
        };
    },
    mounted(){
        Bus.$on('fieldAddedToEditor', data => {
            this.templateEditor.widgets.add( data['button'], {
                inline: true,
                template: '<span><span class="'+data['button']+' cke_widget_element projectDataShow" data-cke-widget-upcasted="1" style="pointer-events: none;border: 1px solid #01b1af;font-size: 12px;padding: 1px 5px;color: #01b1af;text-align: center;width: 170px;margin-right:5px;maring-left:5px" disabled>'+data['text']+'</span><span class="projectDataHidden">$'+data['buttonCode']+'</span></span>',
                upcast: function( element ) {
                    return element.name === 'span' && element.hasClass( data['button'] );
                },
                init: function() {
                }
            } );

            this.templateEditor.execCommand(data['button']);
        });
    },
    watch  : {
        options() {
            this.atValues = this.options.map(this.mapValues);
        },
    },
    methods: {
        emit(value, batch) {
            this.$emit('input', value);
        },
        onReady( editor )  {
            this.templateEditor = editor;
        },
    }
}
</script>

<style>
.ck-editor__editable {
    min-height: 200px;
}

a.cke_button_off:hover, a.cke_button_off:focus, a.cke_button_off:active {
    background: #e5e5e5;
    border: 1px #bcbcbc solid;
    padding: 2px 5px !important;
}
a.cke_button_expandable.cke_button_off:hover, a.cke_button_expandable.cke_button_off:focus, a.cke_button_expandable.cke_button_off:active {
    padding: 2px 2px !important;
}
.cke_toolgroup{
    display:contents !important;
}
.cke_editable p, .cke_editable div{
    margin:0 !important;
}
</style>

